export default "__VITE_ASSET__t8gkuLY0__"